import { render, staticRenderFns } from "./CourseEditor.vue?vue&type=template&id=9033985c&scoped=true&"
import script from "./CourseEditor.vue?vue&type=script&lang=ts&"
export * from "./CourseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CourseEditor.vue?vue&type=style&index=0&id=9033985c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9033985c",
  null
  
)

export default component.exports